export const intervalTypesEnum = {
    'oneTime': 'one-time', //разовый
    'regular': 'regular', //регулярный
    'biweekly': 'biweekly', //раз в 2 недели
    'customDays': 'custom-days', //в определенные дни
}